
import FamiliasModule from "@/store/modules/FamiliasModule";
import { AuthModule } from "@/store/modules/auth";
import { computed, defineComponent } from "vue";
import { useRouter } from "vue-router";
import { useStore } from "vuex";
import { getModule } from "vuex-module-decorators";

export default defineComponent({
  name: "kt-user-menu",
  components: {},
  setup() {
    const router = useRouter();
    const store = useStore();
    const authModule = getModule(AuthModule, store);
    const familiaModule = getModule(FamiliasModule, store);

    const signOut = () => {
      try {
        authModule.logout();
      } catch (err) {
        console.error(err);
      }
      router.push({ name: "acceso-familias" });
    };

    const familia = computed(() => {
      return familiaModule.familia;
    });

    return {
      familia,
      signOut,
    };
  },
});
